import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/whatsapp";

export default function FloatingWhatsApp() {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat with Nidan Diagnostic Centre on WhatsApp"
      className="fixed z-40 bottom-5 right-5 sm:bottom-7 sm:right-7 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebd5a] text-white font-semibold py-3.5 px-5 rounded-full shadow-2xl animate-wa-pulse transition-colors"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">WhatsApp</span>
    </a>
  );
}
